import Footer from './Footer';
import Header from './Header';

export default function SafeguardingPolicy() {
  return (
    <>
      <Header />
      <div className="container lp-privacy">
        <h2 className="mt-5">TRADE LENDA</h2>
        <hr />
        <h5>Child & Youth Safeguarding Policy</h5>

        <div className="md:p-7 md:mr-6">
          <h5 className="">Purpose</h5>
          <p className="text-xxs md:text-xs text-gray07 mt-6 mb-5">
            This document outlines TRADE LENDA's Child & Youth Safeguarding
            Policy, which illustrates TRADE LENDA's commitment to support and
            respect child and youth rights to be protected from violence and
            abuse. We are committed to safeguarding the welfare of all children
            and young people and ensuring a safe, secure, and inclusive
            environment.
          </p>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <h5 className="">Scope</h5>
          <p className="">This policy applies to:</p>
          <ul className="text-xxs md:text-xs text-gray07 mt-6 mb-5">
            <li>All staff, contractors, and volunteers</li>
            <li>Any individual working on behalf of or with TRADE LENDA</li>
            <li>
              All programs, events, and activities involving individuals under
              the age of 18
            </li>
            <li>
              These also include, but are not limited to: employees, volunteers,
              consultants, contractors, partners and any other TRADE LENDA
              representatives.
            </li>
          </ul>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <h5 className="">Definitions</h5>
          <p className="text-xxs md:text-xs text-gray07 mt-6 mb-5">
            The Child and Youth Safeguarding Policy reflects the definitions
            below:
          </p>

          <h6 className="font-bold mt-4">Abuse</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Includes Physical Abuse, Sexual Abuse, Emotional Abuse and
            Exploitation;
          </p>

          <h6 className="font-bold mt-3">Physical Abuse</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Is the deliberate application of force by any person (including
            Children, Youth or Other Persons) to any part of the body of the
            child and/or youth, which results or may result in non-accidental
            harm or injury to a child and/or youth. Physical Abuse may include
            shaking, choking, biting, kicking, burning, poisoning, holding a
            child and/or youth under water, or any other harmful or dangerous
            use of force or restraint.
          </p>

          <h6 className="font-bold mt-3">Sexual Abuse</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Occurs when a person (including Children, Youth or Other Persons)
            uses a child and/or youth for sexual purposes. Sexual Abuse includes
            fondling, intercourse, incest, sodomy, exhibitionism, and commercial
            exploitation through prostitution or the production of pornographic
            materials.
          </p>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Sexual Abuse may include, but is not limited to, permitting,
            encouraging or requiring a child and/or youth to engage in any of
            the following activities if they occur between a person (including
            Children, Youth or Other Persons) and a child and/or youth:
          </p>

          <ul className="text-xxs md:text-xs text-gray07 mt-2 mb-3 list-disc pl-5">
            <li>
              using or engaging in sexually provocative language, acts or
              conduct towards a child and/or youth;
            </li>
            <li>
              rough-housing or engaging in conduct which involves physical
              contact with a child and/or youth and which is sexually suggestive
              in nature;
            </li>
            <li>
              kissing, fondling, caressing, patting or pinching a child and/or
              youth or engaging in sexual intercourse or other sexual conduct
              designed to sexually stimulate either or both of TRADE LENDA
              personnel and child and/or youth;
            </li>
            <li>
              using sexual remarks, jokes, innuendo or taunting about a child
              and/or youth's body or sexual orientation or uttering, either
              verbally or in writing, invitations, requests or sexually
              suggestive remarks or displaying pornographic or sexually
              suggestive material to a child and/or youth;
            </li>
            <li>
              conduct of a sexual nature for the stimulation, gratification,
              profit and self-interest of TRADE LENDA personnel who are in a
              position of trust or authority or with whom the Child and/or Youth
              are in a relationship of dependency; and/or
            </li>
            <li>
              prostitution or production of material of a pornographic nature.
            </li>
          </ul>

          <h6 className="font-bold mt-3">Emotional Abuse</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Involves actions towards a child and/or youth that cause or could
            cause serious behavioural, cognitive, emotional, or mental disorders
            in the child and/or youth. Emotional Abuse also occurs when a person
            (including Children, Youth or Other Persons) makes verbal threats,
            socially isolates a child and/or youth, intimidates, exploits,
            terrorizes, or routinely makes unreasonable demands on a child
            and/or youth.
          </p>

          <h6 className="font-bold mt-3">Exploitation</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Refers to situations whereby an abuser makes unfair profit and/or
            takes advantage of unequal power and/or economic status of a child
            and/or youth.
          </p>

          <h6 className="font-bold mt-3">Neglect/failure to provide</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Occurs when a child's parent(s)/legal guardian(s) or caregivers do
            not provide the requisite attention to the child's emotional,
            psychological, or physical development when they have the means,
            knowledge and access to services to do so; or failure to protect the
            child from exposure to danger.
          </p>

          <h6 className="font-bold mt-3">
            Best Interests of Children and Youth
          </h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            The principle of best interests applies to all actions concerning
            children and youth and requires active measures to protect their
            rights. These measures will promote child and youth safety;
            physical, emotional and developmental needs; well-being of children
            and youth; and support and assist children and youth to realize
            their rights. This includes their participation to ensure that their
            opinions are heard in matters affecting them.
          </p>

          <h6 className="font-bold mt-3">Child (or Children)</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Child (or Children) is defined as any person who is under the age of
            18 years, unless the national laws in which the Organization is
            carrying out the children's programs prescribe a lower age of
            majority.
          </p>

          <h6 className="font-bold mt-3">Other Person</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Other Person means any person who is older than youth as defined
            herein, i.e. "Other Person" means a person who is aged 35 years of
            age or older.
          </p>

          <h6 className="font-bold mt-3">Protection of Children and Youth</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            The responsibility, actions and measures taken to prevent and
            respond to Abuse, Exploitation and violence against children and
            youth. Youth is defined as any person who is above the age of 18
            years and under the age of 35 years.
          </p>
        </div>

        <div className="md:p-7 md:mr-6 mt-6 mb-5">
          <h5 className="">Policy</h5>

          <h6 className="font-bold mt-4">1. Prevention</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            TRADE LENDA is committed to taking measures to address risk factors
            and prevent abuse and exploitation before it occurs. Prevention
            measures include organizational policies, procedures and codes of
            conduct for protecting children and youth; capacity building for all
            those who work with children and youth; awareness raising and good
            practice for minimizing the risks to children and youth.
          </p>

          <h6 className="font-bold mt-4">2. Awareness</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            TRADE LENDA will ensure that all personnel involved with child or
            youth programs are aware of child and youth protection risks,
            policies and procedures; including national laws and international
            instruments, as applicable.
          </p>

          <h6 className="font-bold mt-4">3. Roles and Responsibilities</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            It is the responsibility of all TRADE LENDA personnel to raise any
            concerns you have or any concerns which are reported to you
            according to this policy. It is not your responsibility to decide
            whether or not child abuse has occurred. It is the responsibility of
            all TRADE LENDA personnel to ensure the delivery of this policy and
            to promote it as relevant in all aspects of their work, to hold
            themselves and others to account and to help create a safe
            environment for all. All TRADE LENDA personnel are required to
            adhere to this Policy and TRADE LENDA's Code of Conduct at all
            times.
          </p>

          <h6 className="font-bold mt-4">
            4. Gender Equality, Diversity, Equity & Inclusion
          </h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            TRADE LENDA will ensure that all policies and procedures to protect
            children and youth take into account gender equality, diversity,
            equity and inclusion. Recognizing that women and men may face
            different risks relating to their safety and protection and that all
            Children and Youth have the equal right to protection, irrespective
            of: race; colour; sex, gender, gender identity or expression and
            sexual orientation; language; disability; religion; political or
            other opinions; national, social or indigenous origin; property;
            birth or other status.
          </p>

          <h6 className="font-bold mt-4">5. Capacity Building & Training</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            TRADE LENDA will develop the capacity of all personnel who work with
            and for children and youth to appropriately prevent, detect and
            respond to abuse and exploitation of children and youth as reflected
            in this policy. Additional training will be implemented as
            appropriate or as policies are updated.
          </p>

          <h6 className="font-bold mt-4">6. Confidentiality and Children</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            TRADE LENDA personnel cannot keep confidences when they involve
            concerns about a child. Any information offered in confidence to
            TRADE LENDA personnel relating to risks or concerns about a child
            should be received on the basis that it will have to be shared with
            the relevant person or people in authority. In the first instance
            this will be a member of the Management Team.
          </p>

          <h6 className="font-bold mt-4">7. Privacy & Personal Data</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            TRADE LENDA personnel must adhere to TRADE LENDA's Privacy Policies.
            All information stored by TRADE LENDA about children and youth must
            be processed in accordance with TRADE LENDA's privacy policies.
            Research with children and youth must be in line with TRADE LENDA's
            Child & Youth Safeguarding Policy. TRADE LENDA's personnel must
            consider how to protect a child's identity, how to share and store
            such content and how to achieve "informed consent". Disputes about
            the use of child images must be raised to the Head, Business
            Development and Growth. TRADE LENDA will retain written records of
            all reports of Abuse of a child or youth. All such records will be
            kept within TRADE LENDA files in accordance with TRADE LENDA's
            Privacy Policies.
          </p>

          <h6 className="font-bold mt-4">8. Informed Consent</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            TRADE LENDA will provide children and youth with all necessary
            details to make an informed decision regarding their participation
            in programs and activities, including any voice recordings, video or
            photographs of children and/or youth that may result from their
            participation. Children and youth will understand how their images
            maybe used and be supported to identify and evaluate any associated
            risks. Personal information and/or images of children and youth will
            only be used after informed consent has been obtained in writing
            from the child, youth, and/or their parent(s) / legal guardian(s)
            (if applicable).
          </p>

          <h6 className="font-bold mt-4">
            9. Virtual Contact with Children & Youth
          </h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Anyone working with or on behalf of TRADE LENDA must adhere to TRADE
            LENDA's guidelines to protect children engaging with TRADE LENDA
            through social media. Social media and technology are evolving
            rapidly and it is the responsibility of managers to consider the
            full range of risks and safeguards required to protect children in
            the activities that they oversee.
          </p>

          <h6 className="font-bold mt-4">
            10. Conduct of TRADE LENDA Personnel
          </h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            TRADE LENDA Personnel MUST:
          </p>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            Prevent
          </p>
          <ul className="text-xxs md:text-xs text-gray07 mt-2 mb-3 list-disc pl-5">
            <li>
              Be aware of potential risks and take appropriate action so as to
              minimize risks
            </li>
            <li>
              Create an environment where concerns can easily and safely be
              raised and discussed
            </li>
            <li>
              Recognize and remedy potential situations which may lead to
              violent acts against children and/or youth
            </li>
            <li>
              Ensure that ALL one-on-one interaction with children and youth be
              done in plain view of other people, i.e. in an open public space,
              in the same room as another person or in a room with large windows
              which permits others to clearly see into the room
            </li>
          </ul>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            Create a Positive Environment
          </p>
          <ul className="text-xxs md:text-xs text-gray07 mt-2 mb-3 list-disc pl-5">
            <li>
              Contribute to an environment where children and youth are
              respected and encouraged to discuss their concerns and rights
            </li>
            <li>
              Ensure that children and youth are aware of their rights, policies
              and resources which are available to them if there is a problem
            </li>
            <li>
              Work with children and youth to define what is acceptable or
              unacceptable behaviour with TRADE LENDA personnel
            </li>
          </ul>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            Report and Respond
          </p>
          <ul className="text-xxs md:text-xs text-gray07 mt-2 mb-3 list-disc pl-5">
            <li>
              Report to TRADE LENDA any concerns involving protection against
              Abuse of children and/or youth (whether by TRADE LENDA personnel
              or by children and/or youth) and take appropriate actions
            </li>
            <li>
              Ensure children and youth are well-informed and participate in the
              decision-making and the types of intervention agreed upon
            </li>
          </ul>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            TRADE LENDA Personnel MUST NEVER:
          </p>
          <ul className="text-xxs md:text-xs text-gray07 mt-2 mb-3 list-disc pl-5">
            <li>
              Abuse or exploit a child or youth or behave in any way that places
              a child or youth at risk of harm
            </li>
            <li>
              Exchange money, gifts, employment, goods or services for sex with
              a child or youth, including sexual favours or other forms of
              humiliating, degrading or exploitative behaviour or any other
              behaviour that could be deemed exploitative of a child or youth
            </li>
            <li>
              Have a child or youth they are working with stay overnight at
              their home unsupervised or sleep in the same room or bed with a
              child or youth
            </li>
            <li>
              Do things for children or youth of a personal nature that they can
              do for themselves
            </li>
            <li>
              Offend, insult, humiliate or degrade a child or youth or
              perpetrate any form of Emotional Abuse
            </li>
            <li>
              Discriminate or provide favourable treatment to one child or youth
            </li>
            <li>Restrain a child or youth</li>
            <li>
              Discipline a child or youth using any form of physical contact, or
              emotional or psychological pressure, abuse or intimidation
            </li>
            <li>Kiss or coaxing a child to kiss the TRADE LENDA personnel</li>
            <li>
              Engage in extended hugging, tickling or coaxing of a child to hug
              the TRADE LENDA personnel
            </li>
            <li>
              Touch a child in any area that would be covered by a bathing suit.
            </li>
            <li>
              Carry a child or have them sit on the lap of the TRADE LENDA
              personnel.
            </li>
            <li>Be alone with child.</li>
            <li>Engage in prolonged physical contact with a child.</li>
          </ul>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            The above is neither an exhaustive nor exclusive list and TRADE
            LENDA will consider all related actions and behaviour which may
            compromise the rights and protection of children and youth.
          </p>

          <h6 className="font-bold mt-4">11. Reporting a Concern</h6>
          <ul className="text-xxs md:text-xs text-gray07 mt-2 mb-3 list-disc pl-5">
            <li>
              TRADE LENDA encourages all personnel to first speak to their
              manager or local human resources representative when they have
              concerns about a policy violation or misconduct, as this is
              typically the best method for addressing problems and allows the
              appropriate management to take action.
            </li>
            <li>
              For suspected or alleged abuse of any kind, TRADE LENDA personnel
              are required to report to a member of the Management Team.
            </li>
            <li>
              In exceptional cases where a person has been discouraged from
              reporting to the Management Team or may fear for his or her job or
              well-being, the ethics@tradelenda.com email is available to bypass
              those normal channels in a confidential manner. All emails sent to
              this address will be processed by the Head, People and Operations.
            </li>
            <li>
              Those who work with or for TRADE LENDA (including TRADE LENDA's
              clients) can also raise a concern without fear of retribution to
              TRADE LENDA's Whistleblowing Service by emailing
              ethics@tradelenda.com
            </li>
            <li>
              If the person reporting to you is at risk of immediate harm,
              danger or threat as a result of TRADE LENDA's personnel or
              programs, you should work to find an immediate safety solution for
              the person reporting and contact the Country Director and/or
              Security immediately. As soon as possible, this information must
              be reported to the Head, People and Operations.
            </li>
          </ul>

          <h6 className="font-bold mt-4">12. Responding to a Concern</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            TRADE LENDA is committed to responding to all complaints and
            concerns of abuse. TRADE LENDA recognizes that disclosures and
            suspicion should always be acted upon swiftly, and if there is an
            urgent child protection situation, for example if a child is in
            imminent danger of abuse, then immediate protective action must be
            taken.
          </p>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            What to do if You Have Concerns About a Child's Wellbeing
          </p>
          <ul className="text-xxs md:text-xs text-gray07 mt-2 mb-3 list-disc pl-5">
            <li>
              The first priority is the immediate safety and welfare of the
              child.
            </li>
            <li>
              Keep calm and act normally; do not say or show that you are
              shocked.
            </li>
            <li>
              Do not investigate or question the child. If a child reports abuse
              directly to you, only ask questions to get enough information to
              understand the complaint (e.g. 'who, what, where, when' questions,
              but not 'why' questions).
            </li>
            <li>
              Never agree to keep a secret. If a child is in danger you will
              have to inform others.
            </li>
            <li>
              Do not directly challenge parents, carers or teachers about your
              concerns.
            </li>
            <li>
              Record all the details that support your suspicion and report this
              in line with internal reporting procedures.
            </li>
          </ul>

          <h6 className="font-bold mt-4">13. Procedures for Complaints</h6>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            When a complaint or concern has been raised, it must be referred
            within 24 hours to TRADE LENDA's Head, People & Operations. This can
            be done on behalf of somebody else and may only involve a suspicion.
          </p>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            Internal Response
          </p>
          <ul className="text-xxs md:text-xs text-gray07 mt-2 mb-3 list-disc pl-5">
            <li>
              Within 72 hours of receiving a complaint or concern, an email
              should be sent to the complainant acknowledging the complaint as
              soon as possible. TRADE LENDA must refer suspected cases of child
              abuse to local statutory authorities where possible.
            </li>
            <li>
              Confidentiality must be maintained throughout the complaints
              process by all staff and witnesses. TRADE LENDA personnel who
              breach confidentiality will be subject to disciplinary action up
              to and including termination of employment. In some cases, such
              breaches constitute breaking the law.
            </li>
          </ul>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            Retaliation Against Complainants, Victims and Witnesses
          </p>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            TRADE LENDA will take action against any personnel, whether they are
            the subject of a complaint or not, who seek or carry out retaliatory
            action against complainants, victims or other witnesses. Personnel
            who are found to do this will be subject to disciplinary action, up
            to and including termination of employment.
          </p>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            Outcomes of Misconduct
          </p>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Personnel who are found to contravene this policy will be subject to
            disciplinary action that may result in dismissal. Where possible,
            TRADE LENDA will refer suspected cases of child abuse to local
            statutory authorities and the process and outcome will be handled by
            said authority. Volunteers, contractors and other representatives
            will have their relationship with TRADE LENDA terminated.
          </p>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            False Allegations
          </p>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            It is extremely rare that staff or other stakeholders are found to
            have raised allegations which they knew to be false. If a member of
            staff from TRADE LENDA is found to have made an allegation that they
            knew to be false they will be subject to disciplinary action, up to
            and including termination of employment.
          </p>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            Complaints about TRADE LENDA's Partners
          </p>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            If TRADE LENDA receives a complaint about a partner organization,
            TRADE LENDA will expect the partner to respond quickly and
            appropriately. TRADE LENDA should assist the partner to ascertain
            its obligations under local law to refer the matter to the police or
            other statutory authorities for criminal investigation. Where
            appropriate, TRADE LENDA should work with the partner to address the
            issue through an appropriate independent investigation. If the
            outcome is that child abuse has occurred, ongoing work with the
            partner cannot involve the individual(s) concerned.
          </p>

          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3 font-bold">
            Receiving External Complaints and Concerns
          </p>
          <p className="text-xxs md:text-xs text-gray07 mt-2 mb-3">
            Complaints raised from outside the organization should be referred
            to TRADE LENDA's ethics@tradelenda.com and must adhere to TRADE
            LENDA's policy and procedures as outlined in this document.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}
